import { Link } from 'react-router-dom';
import '../App.css';
import './VersionsPage.css';
import { RELEASE_ROUTES, LATEST_RELEASE } from '../router/routes';
import ThemeToggle from '../components/shared/theme-toggle';
import LanguageToggle from '../components/shared/language-toggle';
import { useReleaseTheme } from '../theme/useReleaseTheme';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import { useLanguage } from '../hooks/useLanguage';
import { t } from '../utils/translations';

function VersionsPage() {
  // Keep the newest release theme as the baseline look for this landing page.
  useReleaseTheme(LATEST_RELEASE);
  useDocumentTitle(null);
  const { currentLanguage } = useLanguage();

  // Newest first for display.
  const versions = [...RELEASE_ROUTES].sort((a, b) => b.slug.localeCompare(a.slug));

  return (
    <div className="App versions-page">
      <ThemeToggle />
      <LanguageToggle />

      <div className="versions-container">
        <header className="versions-header">
          <h1 className="versions-title">{t('versions_page_title', currentLanguage)}</h1>
          <p className="versions-subtitle">{t('versions_page_subtitle', currentLanguage)}</p>
        </header>

        <ul className="versions-grid">
          {versions.map(({ slug }) => {
            const isLatest = slug === LATEST_RELEASE;
            return (
              <li key={slug} className="versions-card-wrapper">
                <Link to={`/${slug}`} className="versions-card">
                  {isLatest && (
                    <span className="versions-badge">
                      {t('versions_latest_badge', currentLanguage)}
                    </span>
                  )}
                  <span className="versions-card-version">12.1.{slug}</span>
                  <span className="versions-card-cta">
                    {t('versions_view_release', currentLanguage)}
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                    >
                      <path
                        d="M5 12h14M13 6l6 6-6 6"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}

export default VersionsPage;
